<!--suppress HtmlUnknownTarget -->
<template>
	<div>
		<main class="bg-gray-300">
			<banner :title="getText('title1')">
				<div class="pt-4">
					<router-link :to="this.getRouteUrl('projects')"
					             type="button"
					             class="bg-gray-900 text-white active:bg-gray-700 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 mt-5">
						{{ this.getText('preview-projects') }}
					</router-link>
				</div>
			</banner>
			<section class="px-8 bg-gray-700">
				<div class="container mx-auto px-4">
					<div class="flex flex-col min-w-0 break-words w-full mb-0 pt-8">
						<div class="flex flex-col md:flex-row">
							<div class="flex flex-row md:flex-col px-4 md:w-4/12">
								<div class="flex self-center flex-col">
									<div class="flex flex-row py-2">
										<div class="text-white p-2 h-10 w-10 text-center items-center justify-center rounded-full"
										     style="min-width: 2.5rem; min-height: 2.5rem;">
											<i class="fas fa-user-check"></i>
										</div>
										<div class="flex items-center">
											<h6 class="text-md rounded-lg text-white font-semibold inline-block pl-4"> {{ this.getText('homepage-1') }}</h6>
										</div>
									</div>
									<div class="flex flex-row py-2">
										<div class="text-white p-2 h-10 w-10 text-center items-center justify-center rounded-full"
										     style="min-width: 2.5rem; min-height: 2.5rem;">
											<i class="fas fa-building"></i>
										</div>
										<div class="flex items-center">
											<h6 class="text-md rounded-lg text-white font-semibold inline-block pl-4"> {{ this.getText('homepage-2') }}</h6>
										</div>
									</div>
								</div>
							</div>
							<div class="flex flex-row md:flex-col px-4 md:w-4/12">
								<div class="flex self-center flex-col">
									<div class="flex flex-row py-2">
										<div class="text-white p-2 h-10 w-10 text-center items-center justify-center rounded-full"
										     style="min-width: 2.5rem; min-height: 2.5rem;">
											<i class="fas fa-people-carry"></i>
										</div>
										<div class="flex items-center">
											<h6 class="text-md rounded-lg text-white font-semibold inline-block pl-4"> {{ this.getText('homepage-3') }}</h6>
										</div>
									</div>
									<div class="flex flex-row py-2">
										<div class="text-white p-2 h-10 w-10 text-center items-center justify-center rounded-full"
										     style="min-width: 2.5rem; min-height: 2.5rem;">
											<i class="fas fa-project-diagram"></i>
										</div>
										<div class="flex items-center">
											<h6 class="text-md rounded-lg text-white font-semibold inline-block pl-4"> {{ this.getText('homepage-4') }}</h6>
										</div>
									</div>
								</div>
							</div>
							<div class="flex flex-row md:flex-col px-4 md:w-4/12">
								<div class="flex self-center flex-col">
									<div class="flex flex-row py-2">
										<div class="text-white p-2 h-10 w-10 text-center items-center justify-center rounded-full"
										     style="min-width: 2.5rem; min-height: 2.5rem;">
											<i class="fas fa-city"></i>
										</div>
										<div class="flex items-center">
											<h6 class="text-md rounded-lg text-white font-semibold inline-block pl-4"> {{ this.getText('homepage-5') }}</h6>
										</div>
									</div>
									<div class="flex flex-row py-2">
										<div class="text-white p-2 h-10 w-10 text-center items-center justify-center rounded-full"
										     style="min-width: 2.5rem; min-height: 2.5rem;">
											<i class="fas fa-couch"></i>
										</div>
										<div class="flex items-center">
											<h6 class="text-md rounded-lg text-white font-semibold inline-block pl-4"> {{ this.getText('homepage-6') }}</h6>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<hr class="mt-8 border-gray-400"/>
				</div>
			</section>
			<section class="relative py-16 bg-gray-700">
				<div class="container mx-auto px-4">
					<div class="items-center flex flex-wrap">
						<div class="w-full md:w-4/12 ml-auto mr-auto px-4">
              <picture>
                <source srcset="/images/homepage-1.webp" type="image/webp">
                <source srcset="/images/homepage-1.jpg" type="image/jpeg">
                <img src="/images/homepage-1" alt="Arhitektūras paraugs saulrietā" style="border-radius: 10px; overflow: hidden;">
              </picture>
						</div>
						<div class="w-full md:w-5/12 ml-auto mr-auto px-4">
							<div class="md:pr-12">
								<div class="hidden md:flex text-gray-700 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-indigo-200">
									<i class="fas fa-building text-xl"></i>
								</div>
								<h3 class="pt-8 md:pt-0 text-white text-3xl font-semibold">{{ this.getText('large-things') }}</h3>
								<ul class="list-none mt-4">
									<li class="py-2">
										<div class="flex items-center">
											<div>
						                        <span class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-gray-700 bg-indigo-200 mr-3">
							                        <i class="fas fa-arrow-right"></i>
						                        </span>
											</div>
											<div>
												<h4 class="text-white ">
													{{ this.getText('large-things-1') }}
												</h4>
											</div>
										</div>
									</li>
									<li class="py-2">
										<div class="flex items-center">
											<div>
						                        <span class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-gray-700 bg-indigo-200 mr-3">
							                        <i class="fas fa-arrow-right"></i>
						                        </span>
											</div>
											<div>
												<h4 class="text-white ">{{ this.getText('large-things-2') }}</h4>
											</div>
										</div>
									</li>
									<li class="py-2">
										<div class="flex items-center">
											<div>
						                        <span class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-gray-700 bg-indigo-200 mr-3">
							                        <i class="fas fa-arrow-right"></i>
						                        </span>
											</div>
											<div>
												<h4 class="text-white ">{{ this.getText('large-things-3') }}</h4>
											</div>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section class="pb-8 relative block bg-gray-900">
				<div class="container mx-auto px-4">
					<div class="flex flex-wrap text-center justify-center pb-16">
						<div class="w-full lg:w-6/12 px-12 pt-12 md:pt-24">
							<h2 class="text-4xl font-semibold text-white">{{ this.getText('actual-experience-title') }}</h2>
							<p class="text-lg leading-relaxed mt-4 mb-4 text-white">{{ this.getText('actual-experience-desc') }}</p>
						</div>
						<div class="w-full lg:w-6/12 px-12 pt-12 md:pt-24">
							<h2 class="text-4xl font-semibold text-white">{{ this.getText('solutions-title') }}</h2>
							<p class="text-lg leading-relaxed mt-4 mb-4 text-white">{{ this.getText('solutions-description') }}</p>
						</div>
					</div>
				</div>
			</section>
		</main>
	</div>
</template>
<script>
	import {mapGetters} from 'vuex';
	import Banner from "./Banner";

	export default {
		name: "landing-page",
		components: {
			Banner,
		},
		computed: {
			...mapGetters(['getText', 'getRouteUrl'])
		},
	}
</script>
